import { StreamChat } from 'stream-chat';
import messageStore from 'store/message.js'
import authStore from 'store/auth.js'
import widgetStore from 'store/widget';
import { get } from 'svelte/store';
import { STREAM_CHAT_API_KEY, avatarRight } from "../constant"

export class StreamChatProvider {

    constructor() {
        if (StreamChatProvider.instance) {
            return StreamChatProvider.instance;
        }
        this.messages = [];
        const client = StreamChat.getInstance(STREAM_CHAT_API_KEY, { enableWSFallBack: true });
        this.client = client;
        const self = this
        this.connectUser().then( res => {
            const { me } = res
            const { id } = me
            self.user = me
            const ids = id.split('@')
            const channel_id = ids[ids.length - 2];
            this.getChannels(channel_id).then( channels => {
                if ( channels.length === 0) {
                    const contacts = get(widgetStore).contacts.split(",");
                    const agent_id = contacts[Math.floor(Math.random()*contacts.length)]
                    self.channel = client.channel('messaging', 
                        channel_id,
                        {
                            name: `Customer query for ${channel_id}`,
                            agent_id
                        }
                    );
                } else {
                    self.channel = channels[0]
                    messageStore.set(self.channel.state.latestMessages)
                    self.channel.addMembers([id]);
                }
                self.channel.watch();
                self.listenForNewMessages();
                // console.log(self.channel)
            }).catch( e => {
                console.log(e)
            })
        });
        StreamChatProvider.instance = this;
    }

    static getInstance() {
        if (StreamChatProvider.instance) return StreamChatProvider.instance
        return new StreamChatProvider()
    }

    async connectUser() {
        const { user, avatar } = get(authStore)
        const { first_name, last_name, id } = user
        const userId = `${id}`

        if (!avatar) authStore.setAvatar(avatarRight);

        return await this.client
        // .connectUser(
        .setGuestUser(
            {
                id: userId,
                name: `${first_name} ${last_name}`,
                image: avatar || avatarRight,
            },
            // "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoiMSJ9.Sdqm2DOAMw5YKmkO4NVPCSCWW5-G2pzDCODxdSjFEdU",
            this.client.devToken(userId),
        );
    }

    async send(message, option = {}) {
        await StreamChatProvider.getInstance().channel.sendMessage({message, option});
    }

    async sendImage(e) {
        const files = e.target.files;
        return await StreamChatProvider.getInstance().channel.sendImage(files[0]);
    }

    getMessages() {
        return get(messageStore).messages;
    }

    listenForNewMessages() {
        this.channel.on('message.new', event => {
            const { message } = event;
            // console.log(event)
            const { user } = message;
            const _userids = user.id.split("@")
            const userid = `@${_userids[1]}@${_userids[2]}` 
            if ( `${get(authStore).user.id}` !== userid ) {
                messageStore.push(event.message)
            }
            const chats = document.getElementById("chat-list");
            // chats.scrollTop = chats.scrollHeight;
            chats.scroll({ top: chats.scrollHeight, behavior: 'smooth' });
        });
    }

    async getChannels(cid = null) {
        if ( !this.client ) {
            const self = this
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    resolve(self.getChannels())
                }, 2000);
            })
        }
        const filter = { type: 'messaging' };
        if (cid) {filter.id = { $in: [cid] }}
        const sort = [{ last_message_at: -1 }];

        return await this.client.queryChannels(filter, sort, {
            watch: true, // this is the default
            // state: true,
        });
    }

    async joinChannel({cid, userId}) {
        const channels = await this.getChannels(cid)
        if ( channels.length === 0) {
            throw Error("No channel found")
        }
        const channel = channels[0]
        messageStore.set(channel.state.latestMessages)
        return await channel.addMembers([userId]);
    }

    async getUser() {
        if ( !this.user ) {
            const self = this;
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    resolve(self.getUser())
                }, 2000)
            })
        }
        return this.user;
    }
}
